import React from 'react';

const UA_FLAG_PNG = 'https://flagcdn.com/w40/ua.png';

/**
 * Прапор лише України (react-phone-number-input передає country — ігноруємо).
 */
export const FlagComponent = ({
  country: _country,
  countryName,
}: {
  country?: string;
  countryName: string;
}): React.ReactElement => (
  <div
    className='custom-flag PhoneInputCountryIcon'
    title={countryName || 'Україна'}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '24px',
      marginRight: '4px',
      borderRadius: '3px',
      overflow: 'hidden',
      flexShrink: 0,
      backgroundColor: '#f0f0f0',
    }}
  >
    <img
      src={UA_FLAG_PNG}
      alt='Україна'
      loading='eager'
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
        const parent = target.parentElement;
        if (parent) {
          parent.textContent = '🇺🇦';
          parent.style.fontSize = '20px';
          parent.style.lineHeight = '24px';
        }
      }}
    />
  </div>
);
